import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Button } from '@oforce/global-components';
import { insuredStakeholderInitialValues, insuredStakeholderValidationFields } from '../model/step';
import { InsuredStakeholderFormFields } from '.';

export default function InsuredStakeholderForm({ formOptions, stakeholder, onSubmit, onCancel }) {
  const validationSchema = yup.object().shape(insuredStakeholderValidationFields);
  const initialValues = insuredStakeholderInitialValues(stakeholder, formOptions);

  return (
    <Formik validationSchema={validationSchema} initialValues={initialValues} enableReinitialize onSubmit={onSubmit}>
      {formik => (
        <>
          <InsuredStakeholderFormFields formOptions={formOptions} />
          <div className="d-flex mt-1 justify-content-end">
            <Button type="button" onClick={formik.handleSubmit} className="mr-2" color="success">
              Save
            </Button>
            <Button
              onClick={() => {
                formik.resetForm();
                onCancel();
              }}
              color="danger"
            >
              Cancel
            </Button>
          </div>
        </>
      )}
    </Formik>
  );
}
